export const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

export const envName = process.env.NEXT_PUBLIC_ENV_NAME || 'prod';